import React, { Component } from 'react';
import { QrHero } from '../../templates';
import { withLanguageContext } from '../../../utils/LanguageContext';

import './styles.css';

/**
 * The hero section of the landing page.
 *
 * @typedef {Object} Props
 * @prop {Object} [content]
 * @prop {Object} [forwardedRef]
 *
 * @augments {Component<Props>}
 */
class QrHeroView extends Component {

	render () {
		const {
			heading,
			href,
		} = this.props.content.qrLandingPage.hero;

		return (
			<QrHero
				{...{
					heading,
					href,
				}}
				className='QrHeroView'
				forwardedRef={this.props.forwardedRef}
			/>
		);
	}

}

export default withLanguageContext(QrHeroView);



// WEBPACK FOOTER //
// ./src/components/views/QrHeroView/QrHeroView.js